import { render, staticRenderFns } from "./btn-top-primary.vue?vue&type=template&id=29e53b72&scoped=true"
import script from "./btn-top-primary.vue?vue&type=script&lang=js"
export * from "./btn-top-primary.vue?vue&type=script&lang=js"
import style0 from "./btn-top-primary.vue?vue&type=style&index=0&id=29e53b72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e53b72",
  null
  
)

export default component.exports